// extracted by mini-css-extract-plugin
export var avatarContainer = "_8c-0";
export var avatarTypingWave = "_8c-i";
export var gray = "_8c-f";
export var green = "_8c-c";
export var icon = "_8c-9";
export var image = "_8c-1";
export var lg = "_8c-6";
export var md = "_8c-5";
export var presenceDot = "_8c-b";
export var red = "_8c-d";
export var sm = "_8c-4";
export var status = "_8c-a";
export var typingDot = "_8c-h";
export var typingPill = "_8c-g";
export var xl = "_8c-7";
export var xs = "_8c-3";
export var xxl = "_8c-8";
export var xxs = "_8c-2";
export var yellow = "_8c-e";